<template>
<div class="card card-dashboard-fourteen" style="height:410px" v-loading='loading'>
    <label class="az-content-label">Pension 
        <span>{{fy}}</span>
        <span style="float:right;font-size:12px;font-weight:600"><router-link class="nav-sub-link" :to='{path:"/adviserdashboard/min_pension",query:{page:"Minimum Pension Status"}}'><i class="fa fa-angle-right"></i>Minimum Pension Status</router-link></span>
    </label>
    
    <div class="card-body" v-show="!isShow">
        <div class="card bd-0 mg-t-5" style="height:100%;">
            <div class="card-header bd bd-b-0 tx-medium tx-black">
                {{title_detail}}
                <!-- <input v-model="message" placeholder="test"> -->
                <button type="button" class="close" aria-label="Close" style="float:right">
                    <span aria-hidden="true" @click="isShow = !isShow">&times;</span>
                </button>
            </div><!-- card-header -->
            <div class="card-body bd bd-t-0">
                <div class="table-responsive" style="height:273px" >
                    <table class="table mg-b-0" style="table-layout:fixed">
                        <thead>
                            <tr>
                                <th>Fund</th>
                                <th>Member</th>
                                <th width=20% v-show="title_detail.includes('PENSION')|title_detail.includes('MEMBERS')">{{th}}</th>
                            </tr>
                        </thead>
                        <tbody v-show="title_detail.includes('PENSION')">
                            <tr v-for='(pension,index) in minPensions' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+pension.trustee__smsf__fund_code,query:{name:pension.trustee__smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):pension.trustee__smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+pension.trustee__smsf__fund_code+'/memberbasic/',query:{name:pension.trustee__smsf__fund_name,page:'Mamber Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):pension.trustee__trustee_name}}
                                    </router-link>

                                </td>
                                <td>{{isSample?'Sample Account '+(index+1):pension.account_name}}</td>
                            </tr>
                        </tbody>
                        <tbody v-show="title_detail.includes('MEMBERS')">
                            <tr v-for='(trustee,index) in trustees_p' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code,query:{name:trustee.smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):trustee.smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code+'/memberbasic/',query:{name:trustee.smsf__fund_name,page:'Mamber Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):trustee.trustee_name}}
                                   </router-link>
                                </td>
                                <td>{{trustee.age}}</td>
                            </tr>
                        </tbody>
                        <tbody v-show="title_detail.includes('Pension phase')">
                            <tr v-for='(trustee,index) in pen_funds' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code,query:{name:trustee.smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):trustee.smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code+'/memberbasic/',query:{name:trustee.smsf__fund_name,page:'Mamber Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):trustee.trustee_name}}
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-show="title_detail.includes('part')">
                            <tr v-for='(trustee,index) in other_funds' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code,query:{name:trustee.smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):trustee.smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code+'/memberbasic/',query:{name:trustee.smsf__fund_name,page:'Mamber Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):trustee.trustee_name}}
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-show="title_detail.includes('Accumulation phase')">
                            <tr v-for='(trustee,index) in acc_funds' :key='index'>
                                <td class="tx-medium">
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code,query:{name:trustee.smsf__fund_name}}">
                                        {{isSample?'Sample Family Super Fund '+(index+1):trustee.smsf__fund_name}}
                                    </router-link>
                                </td>
                                <td>
                                    <router-link :to="{path:'/funddashboard/'+trustee.smsf__fund_code+'/memberbasic/',query:{name:trustee.smsf__fund_name,page:'Mamber Basic Details'}}">
                                        {{isSample?'Mr Mike Sample '+(index+1):trustee.trustee_name}}
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!-- table-responsive -->
            </div><!-- card-body -->
        </div><!-- card -->
    </div>
        
    <div class="card-body" v-show="isShow">
        <div class="row mg-t-15 mg-b-20">
            <div class="col-6">
                <h4 style="font-size: 20px;">{{minpensionsLen}} 
                    <a style="font-size:18px;color:gray" @click="minpensionsLen>0 && showDetail('minPension')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h4>
                <label class="label-custom">{{minpensionsLen>1?'Pension accounts':'Pension account'}}</label>
                <div style="height:42px">
                    <span>have not reached the minimum pension limit</span>
                </div>
                <div class="progress mg-t-5 ht-5">
                    <div class="progress-bar" :style="{'width':minpensionsPer+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <small>{{minpensionsPer}}% of pension accounts</small>
            </div><!-- col -->
            <div class="col-6">
                <h4 style="font-size: 20px;">{{trustees_pLen}} 
                    <a style="font-size:18px;color:gray" @click="trustees_pLen>0 && showDetail('Member')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h4>
                <label class="label-custom">{{trustees_pLen>1?'Members':'Member'}}</label>
                <div style="height:42px">
                    <span>have not commenced a pension but met the preservation age</span>
                </div>
                <div class="progress mg-t-5 ht-5">
                    <div class="progress-bar bg-teal" :style="{'width':trustees_pPer+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <small>{{trustees_pPer}}% of members</small>
            </div><!-- col -->
        </div><!-- row -->
        <div class="az-list-item">
            <div>
                <h6>No. of funds</h6>
                <span>- all Members in Pension phase</span>
            </div>
            <div>
                <h6 class="tx-primary">{{pen_funds_len}} 
                    <a style="font-size:18px;color:gray" @click="pen_funds_len>0 && showDetail('PEN')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h6>
                <span>{{((pen_funds_len/total_len)*100).toFixed(2)}}% of funds</span>
            </div>
        </div><!-- list-group-item -->
        <div class="az-list-item">
            <div>
                <h6>No. of funds</h6>
                <span>- part Pension part Accumulation</span>
            </div>
            <div>
                <h6 class="tx-primary">{{other_funds_len}} 
                    <a style="font-size:18px;color:gray" @click="other_funds_len>0 && showDetail('OTHER')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h6>
                <span>{{((other_funds_len/total_len)*100).toFixed(2)}}% of funds</span>
            </div>
        </div><!-- list-group-item -->
        <div class="az-list-item">
            <div>
                <h6>No. of funds</h6>
                <span>- all Members in Accumulation phase</span>
            </div>
            <div>
                <h6 class="tx-primary">{{acc_funds_len}} 
                    <a style="font-size:18px;color:gray" @click="acc_funds_len>0 && showDetail('ACC')" role="button" aria-expanded="false"><i class="fa fa-file-text"></i></a>
                </h6>
                <span>{{((acc_funds_len/total_len)*100).toFixed(2)}}% of funds</span>
            </div>
        </div><!-- list-group-item -->
    </div><!-- card-body -->
    </div><!-- card -->
</template>
<script>
import dateformats from "../../../utils/dateformats"
export default {
    name:'pension',
    components: { 
        
    },
    data(){
        return{
            isSample:false,
            fy: '('+dateformats.getFinancialYear()+')',
            minPensions:[],
            minpensionsLen:'',
            minpensionsPer:'',
            trustees_p:[],
            trustees_pLen:'',
            trustees_pPer:'',
            pen_funds:[],
            pen_funds_len:'',
            other_funds:[],
            other_funds_len:'',
            acc_funds:[],
            acc_funds_len:'',
            total_len:'',
            isShow:true,
            title_detail:'',
            th:'',
            loading:true
        
        }
    },
    created(){
        this.getPensionData();
    },
    methods:{
        getPensionData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = localStorage.getItem('brand_code')
            this.isSample = userdetail['sample'];
            this.$api.adviserdashboard_api.pensionInfo(brand).then(response =>{
                //get the investments data from response
                this.minPensions = response.data["minpensions"];
                this.minpensionsLen = this.minPensions.length;
                this.minpensionsPer = response.data["per_minpensions"];
                this.trustees_p = response.data["trustees_p"];
                this.trustees_pLen = this.trustees_p.length;
                this.trustees_pPer = response.data['per_trustees']
                this.pen_funds = response.data['trst_pen']
                this.acc_funds = response.data['trst_acc']
                this.other_funds = response.data['trst_other']
                this.pen_funds_len = response.data['pen_len']
                this.acc_funds_len = response.data['acc_len']
                this.other_funds_len = response.data['other_len']
                this.total_len = this.pen_funds_len+this.acc_funds_len+this.other_funds_len
                this.loading=false
            });
        },
        showDetail(title){
            this.isShow = !this.isShow
            if(title==='minPension'){
                this.title_detail = 'PENSION ACCOUNTS have not reached the minimum pension limit' 
                this.th='Account'
            }else if(title==='Member'){
                this.title_detail = 'MEMBERS have not commenced a pension but met the preservation age'
                this.th='Age'
            }else if(title==='PEN'){
                this.title_detail = 'FUNDS - all Members in Pension phase'
            }else if(title==='OTHER'){
                this.title_detail = 'FUNDS - part Pension part Accumulation'
            }else{
                this.title_detail = 'FUNDS - all Members in Accumulation phase'
            }
            
        }
    }
}
</script>
<style scoped>
.label-custom{
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 0;
    display: block;
    letter-spacing: .5px;
}
</style>